import React from "react";
import Stars from "./Stars";
import { ReviewLike, averageBlendedRating } from "../utils/reviewScore";

function avg(vals: (number | null | undefined)[]): number | null {
  const nums = vals.filter((v): v is number => typeof v === "number");
  return nums.length ? nums.reduce((s, v) => s + v, 0) / nums.length : null;
}

function CriteriaRow({ label, value }: { label: string; value: number | null }) {
  if (value === null) return null;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
      <span style={{ fontSize: 13, color: "#6b7280", minWidth: 110 }}>{label}</span>
      <Stars rating={value} />
      <span style={{ fontSize: 13, color: "#374151" }}>{value.toFixed(1)}</span>
    </div>
  );
}

export default function CriteriaBreakdown({
  reviews,
  role = "guest",
}: {
  reviews: ReviewLike[];
  role?: "guest" | "host";
}) {
  if (reviews.length === 0) return null;

  const blendedAvg = averageBlendedRating(reviews);
  const cleanlinessAvg = avg(reviews.map((r) => r.cleanliness));
  const communicationAvg = avg(reviews.map((r) => r.communication));
  const accuracyAvg = role === "guest" ? avg(reviews.map((r) => r.accuracy)) : null;
  const valueAvg = role === "guest" ? avg(reviews.map((r) => r.valueScore)) : null;
  const respectAvg = role === "host" ? avg(reviews.map((r) => r.respectRules)) : null;

  return (
    <div style={{ marginBottom: 16, paddingBottom: 16, borderBottom: "1px solid #f3f4f6" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
        <span style={{ fontSize: 30, fontWeight: 700, color: "#111827" }}>{blendedAvg?.toFixed(2)}</span>
        <div>
          <Stars rating={blendedAvg ?? 0} />
          <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 2 }}>
            {reviews.length} review{reviews.length !== 1 ? "s" : ""}
          </div>
        </div>
      </div>
      <CriteriaRow label="Cleanliness" value={cleanlinessAvg} />
      <CriteriaRow label="Communication" value={communicationAvg} />
      {role === "guest" && <CriteriaRow label="Accuracy" value={accuracyAvg} />}
      {role === "guest" && <CriteriaRow label="Value" value={valueAvg} />}
      {role === "host" && <CriteriaRow label="House rules" value={respectAvg} />}
    </div>
  );
}
